import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getToken } from '../../user/actions/token/GetToken'
import { connect } from 'react-redux'
import lightwallet from 'eth-lightwallet'
import {
  Container,
  Header,
  Segment,
  Message
} from 'semantic-ui-react'

import BuyToken from './components/BuyToken';
import SellToken from './components/SellToken';

class Token extends Component {
	
    constructor(props) {
        super(props)

    }

    componentWillMount(){
		
        let ks = lightwallet.keystore.deserialize(this.props.authData.keystore)
        let address = ks.getAddresses()

        let { dispatch } = this.props
		
        dispatch(getToken(address[0]))
    }
	
    render() {

        let { memberId, balanceOf, authData } = this.props

        if(memberId === 'N-N'){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        } 

        if(memberId !== '0'){
			
            if(balanceOf === 'N-N'){
                return(<Segment style={{  minHeight: 700 }} vertical loading />)
            } 
		
            if (balanceOf === '0 DAC'){
                
                return <BuyToken authData={authData} />
            } else {
                
                return <SellToken authData={authData} />
            }

        } else {
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Header as='h1' content='Token' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                    <Container textAlign='left' text>
                        <Message error content='To buy or sell token you should be a citizen. Go to the city page and become a citizen.'/>
                    </Container>
                </Segment>
			)

        }
    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.token.data.memberId,
        balanceOf: state.token.data.balanceOf,
    }
}

export default connect(mapStateToProps)(Token)

Token.propTypes = {
    balanceOf: PropTypes.string,
    memberId: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/token/Token.js